import { Component, EventEmitter, Input, Output, forwardRef, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { bbGenerateShortId } from '../../../shared/utils/bbGenerateShortId.util';

export interface BbToggleOption {
	label: string;
	itype: string;
	type: string;
}
@Component({
	selector: 'bb-button-toggle',
	templateUrl: './bb-button-toggle.component.html',
	styleUrls: ['./bb-button-toggle.component.scss'],
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		useExisting: forwardRef(() => BbButtonToggleComponent),
		multi: true
	}]

})

export class BbButtonToggleComponent implements ControlValueAccessor, OnInit {
	@Input() options: BbToggleOption[];
	@Output() selected = new EventEmitter<BbToggleOption>();

	selectedOption: BbToggleOption;
	el: HTMLElement;
	propagateChange: any;
	id = bbGenerateShortId();

	ngOnInit() { }

	onOptionClicked(option: BbToggleOption) {
		this.selectedOption = option;
		this.selected.emit(option);
		if (this.propagateChange) {
			this.propagateChange(this.selectedOption);
		}
	}

	writeValue(value: BbToggleOption) {
		if (value) {
			this.selectedOption = value;
		}
	}

	registerOnChange(fn: any) {
		this.propagateChange = fn;
	}

	registerOnTouched() {

	}
}
